
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { assetUrl } from "@/config/assets";

interface FeatureBoxProps {
  title: string;
  description: string;
  className?: string;
}

const FeatureBox: React.FC<FeatureBoxProps> = ({ title, description, className = "" }) => {
  return (
    <Card className={`h-full bg-elfGreen-lighter ${className}`}>
      <CardHeader className="pb-2">
        <CardTitle className="text-xl font-bold">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700">{description}</p>
      </CardContent>
    </Card>
  );
};

const FeatureBoxes = () => {
  const features = [
    {
      title: "Start Here Without an Account",
      description: "Browse Christmas ideas and get three free personalized PDF deliveries per email address. Use a first name or nickname and one small detail to get started."
    },
    {
      title: "Personalized Letter Creation",
      description: "Tell your elf about a kind moment, a favorite hobby, or a little adventure. AI helps turn your details into a note you can review before sharing."
    },
    {
      title: "Help for Those Last-Minute Moments",
      description: "Forgot to move the elf? Need a late-arrival explanation? Find a short answer and a sample note in our elf help guides."
    },
    {
      title: "See It Before You Send It",
      description: "Read your generated letter on its festive letterhead before requesting the PDF. You decide whether the wording is right for your family."
    },
    {
      title: "Printable PDFs Delivered by Email",
      description: "Preview your personalized letter, then enter your email address. We'll send the festive PDF to your inbox so you can open the attachment and print it at home."
    },
    {
      title: "Continue at The Magic Letter Box",
      description: "For letters throughout December and beyond, explore the paid Family membership: unlimited letters, premium templates, and saved history in a separate account."
    }
  ];

  return (
    <div className="relative">
      {/* Elf character positioned below the grid instead of in the center */}
      <div className="hidden md:flex justify-center my-12">
        <img 
          src={assetUrl("homepage-media/cheerful-christmas-elf-green-outfit.avif")}
          alt="Cheerful Christmas elf in green outfit"
          title="Elf Letter Helper"
          width="250"
          height="350"
          className="max-w-[200px] lg:max-w-[250px] h-auto animate-float"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature, index) => (
          <FeatureBox
            key={index}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
      
      {/* Mobile elf - only visible on small screens */}
      <div className="md:hidden flex justify-center my-8">
        <img 
          src={assetUrl("homepage-media/cheerful-christmas-elf-green-outfit.avif")}
          alt="Cheerful Christmas elf in green outfit"
          title="Elf Letter Helper"
          width="150"
          height="210"
          className="max-w-[150px] h-auto animate-float"
        />
      </div>
    </div>
  );
};

export default FeatureBoxes;
